
























































import Vue, { PropOptions } from 'vue'
import { SearchFacets, SearchFacetValues } from '@/search/types'
import orderBy from 'lodash/orderBy'
import { FACET_TYPE } from '@/search/const'
import FilterItem from '@/search/components/FilterItem.vue'
import HeaderSection from '@/search/components/HeaderSection.vue'

export default Vue.extend({
  components: {
    FilterItem,
    HeaderSection
  },
  props: {
    initFacets: {
      type: Array,
      required: true
    } as PropOptions<string[]>,
    searchFacets: {
      type: Array,
      required: true
    } as PropOptions<SearchFacets[]>
  },
  data(): {
    toggleSection: Array<number>
    facetValueNames: Array<string>
  } {
    return {
      toggleSection: [],
      facetValueNames: this.initFacets
    }
  },
  computed: {
    routeQuery(): { [key: string]: string } {
      return this.$route.query as { [key: string]: string }
    },
    facetType(): {[key: string]: string} {
      return FACET_TYPE
    }
  },
  watch: {
    initFacets(values: Array<string>){
      this.facetValueNames = values
    }
  },
  methods: {
    sortFacetValues(
      facetValuesArray: SearchFacetValues[]
    ) {
      return orderBy(facetValuesArray, 'facetValueDisplayOrder', 'asc')
    },
    selectedMethodLabel(value: string): any {
      const labelVal: Array<string> = []
      this.searchFacets.forEach(item => {
        if (item.facetKeyId == value) {
          item.facetValues.forEach((item1 : SearchFacetValues) => {
            if (this.facetValueNames.indexOf(item1.facetValueName) >= 0) {
              labelVal.push(item1.facetValueDisplayName)
            }
          })
        }
      })
      return labelVal.join('/')
    },
    onChangeSelection() {
      this.$emit('updateParams', {
        facetValueNames: this.facetValueNames
      })
    },
    toggleSectionHandler(value: number) {
      if (this.toggleSection.includes(value)) {
        this.toggleSection.splice(this.toggleSection.indexOf(value), 1)
      } else {
        this.toggleSection.push(value)
      }
    }
  }
})
